import { onUnmounted, ref } from 'vue';
const TIMEROUT = 1000;

export const useSuccessScreen = () => {
  const isSuccessVisible = ref(false);
  const timerId = ref<ReturnType<typeof setTimeout> | null>(null);

  const showSuccessScreen = () => {
    timerId.value = setTimeout(() => {
      isSuccessVisible.value = true;
    }, TIMEROUT);
  };

  const hideSuccessScreen = () => {
    isSuccessVisible.value = false;
  };

  onUnmounted(() => {
    if (timerId.value) {
      clearTimeout(timerId.value);
    }
  });

  return {
    isSuccessVisible,
    showSuccessScreen,
    hideSuccessScreen
  };
};
